import React from 'react';

function ScoreDeltaCard({ label, orig, next, delta, onClick }) {
  return (
    <div
      className={`impact-score-card${onClick ? ' impact-score-card--clickable' : ''}`}
      onClick={onClick}
    >
      <div className="impact-score-label">{label}</div>
      <div className="impact-score-row">
        <span className="impact-score-old">{orig}%</span>
        <span className="impact-score-arrow">→</span>
        <span className="impact-score-new">{next}%</span>
      </div>
      {delta !== 0 && (
        <div className={`impact-score-delta ${delta > 0 ? 'impact-score-delta--pos' : 'impact-score-delta--neg'}`}>
          {delta > 0 ? '+' : ''}{delta} pts {delta > 0 ? '▲' : '▼'}
        </div>
      )}
    </div>
  );
}

const ImpactTab = ({ result, onTabChange }) => {
  const {
    atsOverall,
    humanOverall,
    originalScores,
    keywordMatches = [],
  } = result;

  if (!originalScores) {
    return (
      <div className="impact-empty">
        <p>Impact data compares your original resume to the optimized version.</p>
        <p>This view is available during an active generation session — re-generate this document to see your improvement metrics.</p>
      </div>
    );
  }

  const origAts = Math.round(originalScores.ats_score || 0);
  const origHuman = Math.round(originalScores.human_score || 0);
  const newAts = Math.round(Number(atsOverall) || 0);
  const newHuman = Math.round(Number(humanOverall) || 0);
  const atsDelta = newAts - origAts;
  const humanDelta = newHuman - origHuman;

  // Build keyword presence sets
  const origKws = originalScores.keyword_matches || [];
  const newPresentSet = new Set(
    keywordMatches.filter(k => k.present).map(k => k.keyword.toLowerCase())
  );

  // Keyword display list — based on original scores keyword list
  const allKeywords = origKws.map(k => {
    const wasPresent = k.present;
    const isNowPresent = newPresentSet.has(k.keyword.toLowerCase());
    const isNew = !wasPresent && isNowPresent;
    return { keyword: k.keyword, wasPresent, isNowPresent, isNew };
  });

  const newlyAddedCount = allKeywords.filter(k => k.isNew).length;
  const matchingCount = allKeywords.filter(k => k.wasPresent || k.isNew).length;

  return (
    <div className="impact-tab">
      {/* Score Delta */}
      <div className="impact-score-grid">
        <ScoreDeltaCard label="ATS SCORE" orig={origAts} next={newAts} delta={atsDelta} onClick={() => onTabChange && onTabChange('scores')} />
        <ScoreDeltaCard label="HUMAN SCORE" orig={origHuman} next={newHuman} delta={humanDelta} onClick={() => onTabChange && onTabChange('scores')} />
      </div>

      {/* JD Keywords */}
      {allKeywords.length > 0 && (
        <div className="impact-section">
          <div className="impact-section-title">JD Keywords Matched</div>
          <div className="impact-kw-count">
            Matching {matchingCount} of {allKeywords.length} JD keywords
            {newlyAddedCount > 0 && (
              <span className="impact-kw-count-new"> · {newlyAddedCount} newly added</span>
            )}
          </div>
          <div className="impact-kw-grid">
            {allKeywords.map((k, i) => (
              <span
                key={i}
                className={`impact-kw-pill${k.isNew ? ' impact-kw-pill--new' : k.wasPresent ? ' impact-kw-pill--present' : ' impact-kw-pill--missing'}`}
              >
                {k.keyword}
                {k.isNew && <span className="impact-kw-new-badge">new</span>}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImpactTab;
